let hoverIcon = () => {
  let hoverIcon = document.querySelectorAll('#pageThreeTrailer .img-with-box')
  
  $(document).on('mouseenter', '.img-with-box', (ev) => {
    if (window.innerWidth >= window.gp_max_md) {
      let that = ev.currentTarget
      that.timer = setTimeout(function () {
        $(that).parent().children('i').addClass('opaZone')
        $(that).find('.trailer-img-default').attr('src', pic)
      }, 1200)
      let gif = $(that).find('.trailer-img-default').data('gif')
      let pic = $(that).find('.trailer-img-default').data('pic')
      $(that).find('.trailer-img-default').attr('src', gif)
    }
  })
  
  $(document).on('mouseout', '.img-with-box', (ev) => {
    if (window.innerWidth >= window.gp_max_md) {
      let that = ev.currentTarget
      clearTimeout(that.timer)
      that.timer = null
      let pic = $(that).find('.trailer-img-default').data('pic')
      $(that).find('.trailer-img-default').attr('src', pic)
      $(that).parent().children('i').removeClass('opaZone')
    }
  })
  
  $(window).resize(() => {
    if ($(window).width() <= 1155) {
      ;[...hoverIcon].map((value) => {
        $(value).parent().find('.icon-play-2').addClass('opaZone')
      })
    } else {
      ;[...hoverIcon].map((value) => {
        $(value).parent().find('.icon-play-2').removeClass('opaZone')
      })
    }
  }).trigger('resize')
  
}

let shareLinkPlay = () => {
  
  if (window.preloadType === 'trailer') {
    $.fn.fullpage.moveTo(3)
    
    
    $(window).on('loadingEffectEnd', () => {
      $('#pageThreeTrailer').find('a.js-video-item').eq(window.preloadNum).click()
    })
    /*  $(window).one('loadingEffectEnd', () => {
        let getVideoId = $('#pageThreeTrailer').find('.js-video-item')[window.preloadNum].dataset.videoId
        lity(`//www.youtube.com/watch?v=${getVideoId}`)
      })*/
    
  }
  
  
  $('.menuBox').find('button').on('click', function (ev) {
    ev.preventDefault()
    $('#sideMenu').sideNav('hide')
    let moveNum = $(this).data('linkpage')
    $.fn.fullpage.moveTo(moveNum)
    return false
  })
  
}

export { hoverIcon, shareLinkPlay }